import { render, staticRenderFns } from "./contentArea.vue?vue&type=template&id=c418ef78&scoped=true&"
import script from "./contentArea.vue?vue&type=script&lang=ts&"
export * from "./contentArea.vue?vue&type=script&lang=ts&"
import style0 from "./contentArea.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contentArea.vue?vue&type=style&index=1&id=c418ef78&lang=scss&scoped=true&"
import style2 from "./contentArea.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c418ef78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
